// Explicitly undefine fetch before polyfilling. Some browsers (so far confirmed Safari 11 and some versions
// of Edge) seem to implement a partially working fetch - window.fetch is defined, so we don't polyfill it,
// but it fails at runtime in some cases (e.g. on all POSTs).
// One example here: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/18775440/
// (We witnessed users on Safari 11 crashing when fetch() was used, so it seems to be broken there as well.)

// This needs to be done in a separate file, otherwise webpack will reorder imports so that the fetch polyfill
// comes before this statement (and thus we'd polyfill, then unset what we just polyfilled).
// @ts-expect-error - Polyfilled later
window.fetch = undefined;
